import Oidc from "oidc-client";

Oidc.Log.logger = console;

let redirectUri = process.env.REACT_APP_MAPPER_WEB_URL + "signinCallback";
let postLogoutUri = process.env.REACT_APP_MAPPER_WEB_URL + "index.html";

const userManagerConfig = {
    //silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent_renew.html`,
    //automaticSilentRenew: true,

    authority: process.env.REACT_APP_AUTH_API_URL,
    client_id: "imbick.mapper.web",
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid profile imbick.mapper.api",
    post_logout_redirect_uri: postLogoutUri
};

//todo consider https://stackoverflow.com/questions/45313129/oidc-client-isloggedin
const userManager = new Oidc.UserManager(userManagerConfig);
export default userManager;
